import { useEffect, useRef } from 'react';
import OneSignal from 'react-onesignal';
import CordovaOneSignal from 'onesignal-cordova-plugin';
import { isPlatform } from '@ionic/react';

const appId = process.env.REACT_APP_ONE_SIGNAL_IDENTIFIER || '';
const env = process.env.REACT_APP_ENV || 'dev';

async function OneSignalInit(): Promise<void> {
    if (isPlatform('cordova')) {
        CordovaOneSignal.initialize(appId);
        try {
            // Check if we can request permission (returns false if already denied or granted)
            const canRequest = await CordovaOneSignal.Notifications.canRequestPermission();
            
            // Only request if we can (meaning it hasn't been requested before)
            if (canRequest) {
                const success = await CordovaOneSignal.Notifications.requestPermission(true);
                console.log('Notification permission granted', success);
            } else {
                // Check current permission status
                const hasPermission = CordovaOneSignal.Notifications.hasPermission();
                console.log('Notification permission status:', hasPermission);
            }
        } catch (error) {
            console.error('Error checking/requesting notification permissions:', error);
        }
    }
}

const useOneSignal = () => {
    const oneSignalInitRef = useRef<boolean>(false);
    useEffect(() => {
        if (!appId || oneSignalInitRef.current) {
            return;
        }

        oneSignalInitRef.current = true;

        if (isPlatform('mobile')) {
            OneSignal.init({
                appId,
                allowLocalhostAsSecureOrigin: env === 'dev',
            });

            try {
                OneSignalInit();
            } catch (err) {
                console.log(err);
            }
        }
    }, []);

    const setExternalUserId = (id: string) => {
        if (isPlatform('cordova')) {
            CordovaOneSignal.login(id);
        } else {
            OneSignal.login(id);
        }
    };

    return { setExternalUserId };
};

export default useOneSignal;
